const { REACT_APP_API_ENDPOINT, REACT_APP_FACEBOOK_APP_ID } = process.env;

type Config = {
  API: string;
  FACEBOOK_APP_ID: string;
};

if (!REACT_APP_API_ENDPOINT || !REACT_APP_FACEBOOK_APP_ID) {
  throw new Error(
    'Missing one of the environment variables: REACT_APP_API_ENDPOINT, REACT_APP_FACEBOOK_APP_ID',
  );
}

export const config: Config = {
  API: REACT_APP_API_ENDPOINT?.endsWith('/')
    ? REACT_APP_API_ENDPOINT.slice(0, -1)
    : REACT_APP_API_ENDPOINT,
  FACEBOOK_APP_ID: REACT_APP_FACEBOOK_APP_ID,
};
